export const FONT_FAMILY = "'Index', 'Montserrat', system-ui, sans-serif"
